import React, {useEffect} from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import mainbg from 'images/mainbg.png';
import styled from 'styled-components';
import { Banner, RequestForm, RequestFormCitizenshipList, RequestFormCityDescription, RequestFormCityList,
	RequestFormClientCategoryList, RequestFormCountryDescription, RequestFormCountryList, RequestFormHotelAmenityList,
	RequestFormHotelDescription, RequestFormHotelList, RequestFormHotelRatingList } from 'components';
import methods from '../data/methods';
import { ExmapleBlockStandart, ExmapleBlockCity, ExmapleBlockCountry, ExmapleBlockOld, ExmapleBlockCustomer,
	ExmapleBlockHotelPricing2, ExmapleBlockHotel, ExmapleBlockHotelSearch, ExmapleBlockOrderDocs, ExmapleBlockOrderInfoNotify,
	ExmapleBlockOrderInfo, ExmapleBlockOrder, ExmapleBlockServiceList, ExmapleBlockUserGroup, ExmapleBlockUsers } from 'containers';
import i18n from 'i18next';
import Error404 from './Error404';

const FilterDiv = styled.div`
	width: 100vw;
	padding: 40px;
	background-image: url(${mainbg});
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center center;
	position: relative;
`;

const LayerColor = styled.div`
	height: 100%;
	width: 100%;
	position: absolute !important;
	top: 0;
	left: 0;
	background-color: rgba(3, 71, 129, 0.6);
	z-index: 20;
`;

const Title = styled.div`
	z-index: 100;
`;

const Container = styled.div`
	margin: 40px;
	
	h2 {
		margin: 0px;
	}
`;

const Line = styled.div`
	height: 1px;
	background-color: ${props => props.theme.lightGray};
	margin: 20px 0px;
`;

const DirectionNote = styled.div`
	margin-top: 20px;
	padding: 14px 16px;
	border-left: 4px solid ${props => props.theme.lightBlue};
	border-radius: 4px;
	background: #eef7fd;
	color: ${props => props.theme.darkBlue};
	font-family: "PT Sans", sans-serif;
`;

const Method = () => {
	const { t } = useTranslation();
	const params = useParams();
	const id = params?.id;
	const method = methods.find(i => String(i.id) === String(id)) ?? null;
	const isOutgoingNotification = id === 'OrderInfoNotify';
	const canExecute = !method?.old && !isOutgoingNotification;

	useEffect(() => window.scrollTo(0, 0), []);

	if (!method) return <Error404 />;

	return (
		<>
			<FilterDiv className='block-fullwidth text-center padding-40'>
				<LayerColor />
				<Title className='color-white col-1 font-24 font-bold'>{t('МЕТОД')} {method.id}</Title>
			</FilterDiv>
			<Banner method={id}/>

			<Container>
				<h2>{t('Описание метода')} {method.id} </h2>

				<div className='text-block pt-sans color-grey'>
					{i18n.language === 'en'&& method?.decription_en?.length > 0 ? method?.decription_en : method?.decription} {method?.warning?.length > 0 && <span className='orange spaced'>{i18n.language === 'en'&& method?.warning_en?.length > 0 ? method?.warning_en : method?.warning}</span>}
				</div>

				{isOutgoingNotification && (
					<DirectionNote>
						{t('Это исходящее уведомление: acase.ru отправляет запрос в систему покупателя.')}
					</DirectionNote>
				)}

				<Line/>

				{method?.standart && <ExmapleBlockStandart id={id} errorResponse={method?.errorResponse}/>}

				{id === 'City' && <ExmapleBlockCity />}

				{id === 'Country' && <ExmapleBlockCountry />}

				{id === 'Customer' && <ExmapleBlockCustomer />}

				{id === 'HotelPricing2' && <ExmapleBlockHotelPricing2 />}

				{id === 'Hotel' && <ExmapleBlockHotel />}

				{id === 'HotelSearch' && <ExmapleBlockHotelSearch />}

				{id === 'OrderDocs' && <ExmapleBlockOrderDocs />}

				{id === 'OrderInfoNotify' && <ExmapleBlockOrderInfoNotify />}

				{id === 'OrderInfo' && <ExmapleBlockOrderInfo />}

				{id === 'Order' && <ExmapleBlockOrder />}

				{id === 'ServiceList' && <ExmapleBlockServiceList />}

				{id === 'UserGroup' && <ExmapleBlockUserGroup />}

				{id === 'Users' && <ExmapleBlockUsers />}

				{method?.old === 1 && <ExmapleBlockOld  id={id}/>}

				{canExecute && <Line/>}

				{canExecute && <RequestForm/>}

				{id === 'CitizenshipList' && <RequestFormCitizenshipList />}

				{id === 'CityDescription' && <RequestFormCityDescription />}

				{id === 'CityList' && <RequestFormCityList />}

				{id === 'ClientCategoryList' && <RequestFormClientCategoryList />}

				{id === 'CountryDescription' && <RequestFormCountryDescription />}

				{id === 'CountryList' && <RequestFormCountryList />}

				{id === 'HotelAmenityList' && <RequestFormHotelAmenityList />}

				{id === 'HotelDescription' && <RequestFormHotelDescription />}

				{id === 'HotelList' && <RequestFormHotelList />}

				{id === 'HotelRatingList' && <RequestFormHotelRatingList />}

			</Container>
		</>
	);
};

export default Method;
